export default "__VITE_ASSET__DTNQIRZU__"